import React, { useEffect } from 'react'
import { useImageUpload } from '../../hooks/useImageUpload'

interface ImageUploaderProps {
  currentImage: string
  onImageUploaded: (imageUrl: string) => void
  onError: (message: string) => void
  onSuccess: (message: string) => void
}

const ImageUploader: React.FC<ImageUploaderProps> = ({
  currentImage,
  onImageUploaded,
  onError,
  onSuccess
}) => {
  const {
    imageUploading,
    imagePreview,
    fileInputRef,
    handleFileUpload,
    triggerFileInput,
    setInitialPreview
  } = useImageUpload(onImageUploaded, onError, onSuccess)

  useEffect(() => {
    if (currentImage) {
      setInitialPreview(currentImage)
    }
  }, [currentImage])

  return (
    <div className='mb-4'>
      <label className='form-label'>Obraz główny *</label>
      <div className='d-flex flex-column'>
        {imagePreview && (
          <div className='mb-3'>
            <img
              src={imagePreview}
              alt='Podgląd'
              className='img-thumbnail mb-2'
              style={{ maxHeight: '200px', objectFit: 'contain' }}
            />
          </div>
        )}

        <div className='d-flex flex-column flex-md-row'>
          <input
            type='file'
            className='d-none'
            ref={fileInputRef}
            accept='image/*'
            onChange={handleFileUpload}
          />

          <button
            type='button'
            className='btn btn-outline-primary mb-2 mb-md-0 me-md-2'
            onClick={triggerFileInput}
            disabled={imageUploading}
          >
            {imageUploading
              ? (
                <>
                  <span className='spinner-border spinner-border-sm me-2' role='status' aria-hidden='true' />
                  Przesyłanie...
                </>
                )
              : 'Wybierz plik'}
          </button>

          {currentImage && (
            <div className='flex-grow-1'>
              <input
                type='text'
                className='form-control'
                value={currentImage}
                readOnly
              />
            </div>
          )}
        </div>
        <small className='form-text text-muted mt-2'>
          Wybierz obraz główny dla artykułu. Zalecane wymiary: 1200x630 pikseli.
        </small>
      </div>
    </div>
  )
}

export default ImageUploader
